module.exports = __webpack_public_path__ + "img/symbol_0.8811aa7b.png";